<template>
  <div id="show_info" style="width: 1198px">
    <el-table :data="tableData" style="width: 100%; padding: 0">
      <el-table-column
        :label="
          payOrRefund == 1
            ? TLang('支付方式', 'home')
            : TLang('退款方式', 'list')
        "
        width="275px;"
      >
        <template slot-scope="scope">
          {{
            payOrRefund == 1
              ? exchangePayWay(scope.row.payway,null,scope.row.payWayDesc)
              : TLang("人工退款", "my")
          }}
        </template>
      </el-table-column>
      <el-table-column :label="TLang('东方福利卡号', 'list')" width="284px;">
        <template slot-scope="scope">
          <span>
            {{
              payOrRefund == 1
                ? !scope.row.account
                  ? "—"
                  : scope.row.account
                : !scope.row.refundAccount
                ? "—"
                : scope.row.refundAccount
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="TLang('支付金额/次额', 'list')" width="290px;">
        <template slot-scope="scope">
          <span>
            {{
              payOrRefund == 1
                ? unionInfo.scale && scope.row.payway == 1
                  ? unionInfo.scale * Number(scope.row.amount)
                  : scope.row.amount
                : unionInfo.scale && scope.row.refundWay == 1
                ? unionInfo.scale * Number(scope.row.refundValue)
                : scope.row.refundValue
            }}{{
              payOrRefund == 1
                ? exchangePayWay(scope.row.payway, "unit",scope.row.payWayDesc)
                : exchangePayWay(scope.row.refundWay, "unit",scope.row.payWayDesc)
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :prop="payOrRefund == 1 ? 'payTime' : 'refundTime'"
        :label="
          payOrRefund == 1 ? TLang('支付时间', 'list') : TLang('退款时间', 'my')
        "
        width="252px;"
      ></el-table-column>
      <el-table-column :label="TLang('状态', 'list')" width="97px;">
        <template slot-scope="scope">
          <span>{{ exchangeStatus(scope.row.status) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "OrderInfo",
  data() {
    return {
      tableData: this.sourceData,
      payOrRefund_way: this.payOrRefund,
    };
  },
  props: ["sourceData", "payOrRefund"],
  watch: {
    payOrRefund(val) {
      this.payOrRefund_way = val;
    },
  },
  beforeCreate() {},
  created() {},
  // 移除滚动事件
  destroyed() {},
  components: {},
  computed: {
    ...mapState({
      unionInfo: "unionInfo",
    }),
  },
  methods: {
    //转换支付与退款状态
    exchangeStatus(val) {
      let stateText = "";
      switch (val) {
        case 1:
          this.payOrRefund_way == 1
            ? (stateText = TLang("支付申请成功", "my"))
            : (stateText = TLang("退款申请成功", "my"));
          break;
        case 2:
          this.payOrRefund_way == 1
            ? (stateText = TLang("支付成功", "list"))
            : (stateText = TLang("退款成功", "my"));
          break;
        case 3:
          this.payOrRefund_way == 1
            ? (stateText = TLang("支付申请失败", "my"))
            : (stateText = TLang("退款申请失败", "my"));
          break;
        case 4:
          this.payOrRefund_way == 1
            ? (stateText = TLang("支付失败", "my"))
            : (stateText = TLang("退款失败", "my"));
          break;
      }
      return stateText;
    },
    //转换支付明细中的方式
    exchangePayWay(val, unit,desc) {
      let payText = "";
      let payUnit = "";
      switch (val) {
        case 1:
          payText = TLang('点卡支付', 'my') ;
          payUnit = TLang('福豆', 'home');
          this.unionInfo.union == "shunfeng"
            ? (payUnit = TLang('丰米', 'my'))
            : this.unionInfo.union == "airchina"
            ? (payUnit = TLang('酒花', 'my'))
            : (payUnit = TLang('福豆', 'home'));
          break;
        case 2:
          payText = TLang('次卡支付', 'my');
          payUnit = TLang('次', 'card');
          break;
        case 3:
          payText = TLang('支付宝支付', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 4:
          payText = TLang('微信支付', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 5:
          payText = TLang('银联', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 6:
          payText = TLang('微信JSAPI', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 7:
          payText = TLang('支付宝WAP', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 8:
          payText = TLang('企业微信JSAPI', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 9: //中粮
          payText = TLang('积分支付', 'my');
          payUnit = TLang('酒花', 'my');
          break;
        case 10: //顺丰
          payText = TLang('积分支付', 'my');
          payUnit = TLang('丰米', 'my');
          break;
        case 11:
          payText = TLang('分销渠道', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 13:
          payText = TLang('企业积分', 'my');
          payUnit = TLang('福豆', 'home');
          break;
        case 14:
          payText = TLang('微信小程序支付', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 17:
          payText = TLang('微信H5', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 19:
          payText = TLang('微信APP', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 15:
          payText = TLang('支付宝', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 16:
          payText = TLang('支付宝WAP', 'my');
          payUnit = TLang('元', 'my');
          break;
        case 18:
          payText = TLang('支付宝APP', 'my');
          payUnit = TLang('元', 'my');
          break;
        default:
          payText = desc;
          payUnit = '';
          break;
      }
      
      return !unit ? payText : payUnit;
    },
  },
};
</script>

<style scoped lang="less">
#show_info {
  font-weight: normal;
}
/deep/ .el-table__body {
  padding: 11px 0;
}
/deep/ .el-table th {
  padding: 0;
  border-bottom: 0 !important;
  height: 40px;
  line-height: 40px;
  background: rgba(247, 247, 247, 1);
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  font-weight: normal;
}
/deep/ .el-table {
  box-sizing: border-box;
}
/deep/ .el-table th .cell,
/deep/ .el-table td .cell {
  padding-left: 0;
}
/deep/ .el-table th:nth-of-type(1) .cell,
/deep/ .el-table td:nth-of-type(1) .cell {
  padding-left: 24px;
}
// /deep/ .el-table th:nth-of-type(2) .cell,
// /deep/ .el-table td:nth-of-type(2) .cell {
//   padding-left: 60px;
// }
// /deep/ .el-table th:nth-of-type(3) .cell,
// /deep/ .el-table td:nth-of-type(3) .cell {
//   padding-left: 58px;
// }
// /deep/ .el-table th:nth-of-type(5) .cell,
// /deep/ .el-table td:nth-of-type(5) .cell {
//   padding-right: 24px;
// }
// /deep/ .el-table td:nth-of-type(4) .cell {
//   // color: rgba(34, 34, 34, 1);
// }
/deep/ .el-table::before {
  // background-color: #fff;
  height: 0;
}
/deep/ .el-table td {
  padding: 13px 0;
  vertical-align: top !important;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  border-bottom: none !important;
}

.info_wrap {
  display: flex;
}
.info_wrap::after {
  content: "";
  display: block;
  visibility: hidden;
  height: 0;
  clear: both;
}
.el-table td .info_right {
  font-size: 12px;
  margin-left: 14px;
  .info_title {
    width: 440px;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    line-height: 20px;
  }
  .info_date {
    color: rgba(102, 102, 102, 1);
    line-height: 14px;
    margin: 1px 0;
  }
  .info_address {
    color: rgba(102, 102, 102, 1);
    line-height: 16px;
    .info_address_br {
      width: 1px;
      height: 10px;
      background: rgba(203, 205, 206, 1);
      display: inline-block;
      margin: 0 8px;
    }
  }
  .info_level {
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
    margin-top: 22px;
    .info_level_answer {
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 12px;
    }
  }
}
</style>
